<template>
  <container-app>
    <header-app
      :title="$t('Drop Location')"
      class="header-brand"
      to="customer"
    ></header-app>
    <wrap>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="input-group mb-3">
            <gmap-autocomplete
              class="form-control"
              @place_changed="setPlace"
            ></gmap-autocomplete>
            <div class="input-group-text icon-input" @click="addMarker">
              {{ $t("Select") }}
              <base-icon icon_name="disc" class="pointer ml-2" />
            </div>
          </div>
          <gmap-map
            @click="mark"
            :center="center"
            :zoom="17"
            style="width: 100%; height: 400px"
          >
            <gmap-marker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :icon="{ url: icon }"
              @click="center = m.position"
            ></gmap-marker>
          </gmap-map>
        </div>
        <img
          src="@/assets/loading.svg"
          width="50"
          v-if="delivery_fee_loading"
          alt=""
        />
        <div class="col-md-5 col-sm-12">
          <div class="mt-5">
            {{ $t("Delivery") }}
            <span class="price">
              {{ exchangePrice(delivery_fee.delivery_fee) }}</span
            >
          </div>
          <div>
            <h4>
              {{ $t("Total Payment") }}
              <span class="price"> {{ exchangePrice(order.total) }}</span>
            </h4>
          </div>
          <div></div>

          <div class="form-group mt-3">
            <button
              class="btn btn-text btn-second-brand btn-md mr-2"
              @click="checkOut(false, true)"
            >
              {{ $t("Review Order") }}
            </button>

            <button
              type="button"
              @click="checkOut(true, true)"
              class="btn btn-brand btn-md"
            >
              <base-icon icon_name="arrow-right-circle" />
              {{ $t("Check Out") }}
            </button>
          </div>
        </div>
      </div>
    </wrap>

    <div
      class="modal shadow-lg fade show"
      tabindex="-1"
      v-if="modal"
      role="dialog"
      style="display: block"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t("Delivery is not available your location") }} !
            </h5>
          </div>
          <div class="modal-footer">
            <button type="button" @click="modal = !modal" class="btn btn-round">
              {{ $t("Close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </container-app>
</template>

<style lang="css">
.vue-map-container .vue-map {
  border-radius: 10px;
}
.vue-map-container {
  border: 1px solid #c0cac4;
  border-radius: 10px;
}
</style>

<script>
import Vue from "vue";
import store from "@/store";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAP_KEY,
    libraries: "places", // necessary for places input
  },
});
export default {
  layout: "default",
  name: "customer",
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  data: () => {
    return {
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      icon: require("@/assets/pin.png"),
      currentPlace: null,
      modal: false,
    };
  },
  computed: {
    model() {
      return store.getters["order/order_info"];
    },
    state_order() {
      return store.getters["order/state_order"];
    },
    btn_state() {
      return store.getters["location_selected/btnState"];
    },
    placeSelected() {
      return store.getters["location_selected/placeSelected"];
    },
    order() {
      return store.getters["order/pending_order"];
    },
    delivery_fee() {
      return store.getters["order/delivery_fee"];
    },
    delivery_fee_loading() {
      return store.getters["order/loading_delivery_fee"];
    },
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
  },
  mounted() {
    if (this.btn_state != "delivery") {
      if (this.placeSelected) {
        this.$router.push({
          name: "detail",
          params: { id: this.placeSelected.slug },
        });
      } else {
        this.$router.push("/");
      }
    }
    if (this.order.lat && this.order.lng) {
      this.selectedMap();
    } else {
      this.geolocate();
    }
  },

  methods: {
    exchangePrice(value_) {
      let value = value_ || 0;

      let val = ((value * this.selected_currency.rate) / 1)
        .toFixed(2)
        .replace(".", ".");
      return (
        this.selected_currency.code +
        " " +
        val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
    mark(event) {
      const marker = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.markers = [];
      this.places = [];
      this.markers.push({ position: marker });
      this.places.push(this.currentPlace);
      this.center = marker;
      this.currentPlace = null;
      this.checkOut(false, false);
    },
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.markers = [];
      this.places = [];
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
        this.checkOut(false, false);
      }
    },

    selectedMap: function () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const marker = {
            lat: this.order.lat,
            lng: this.order.lng,
          };

          this.markers = [];
          this.places = [];
          this.markers.push({ position: marker });
          this.places.push(this.currentPlace);
          this.center = marker;
          this.currentPlace = null;
          this.checkOut(false, false);
        },
        (error) => {}
      );
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const marker = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.markers = [];
          this.places = [];
          this.markers.push({ position: marker });
          this.places.push(this.currentPlace);
          this.center = marker;
          this.currentPlace = null;
        },
        (error) => {}
      );
    },

    async checkOut(checkOut = true, push = false) {
      this.order.lat = this.center.lat;
      this.order.lng = this.center.lng;
      this.model.lat = this.center.lat;
      this.model.lng = this.center.lng;
      this.$store.dispatch("order/setOrderInfo", this.model);
      await store.dispatch("order/CalcDeliveryFee", this.order);
      if (!this.delivery_fee.available) {
        this.modal = true;
        return;
      }
      if (checkOut == true && push == true) {
        await this.$store.dispatch("order/setOrderInfo", this.model);
        await store.dispatch("order/submitPendingOrder", { id: 0 });
        if (this.state_order) {
          await this.$store.dispatch("order/clearOrder");
          await this.$router.push({ name: "ordercompleted" });
        }
      } else {
        if (push == true) this.$router.push({ name: "basket" });
      }
    },
  },
};
</script>